/* @flow */

import { getEventPlugins } from '@e180/domain/lib/event/util';
import { assertObject } from '@e180/util/lib/assert';
import { isArray } from '@e180/util/lib/type';

import { signupPlugin } from 'src/shared/app/feature/settings/featureSettings';

import type { BraindateEvent } from '@e180/domain/lib/event/type';

export function getSignupOptions(event: BraindateEvent): ?Object {
  const options = getEventPlugins(event)[signupPlugin];

  if (options) {
    assertObject(options, 'options');

    return options;
  }
}

export function isLoginShownBeforeSignup(event: BraindateEvent): boolean {
  return !!(getSignupOptions(event) || {}).show_login_first;
}

export function getSignupI18nFields(event: BraindateEvent): ?Array<Object> {
  const { fields } = getSignupOptions(event) || {};

  if (isArray(fields)) {
    return fields;
  }
}

export function getSignupExtraFields(event: BraindateEvent): ?Array<Object> {
  const { extra_fields: extraFields } = getSignupOptions(event) || {};

  if (isArray(extraFields)) {
    return extraFields;
  }
}
